import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'email-confirmation.title',
    defaultMessage: 'Enter your password to confirm your updated email',
  },
  emailLabel: {
    id: 'account.verification.form.emailField.label',
    defaultMessage: 'Updated email',
    description:
      'The label shown above a disabled email field when the user is confirming that they have updated their email.',
  },
  incorrectPassword: {
    id: 'email-confirmation.form.incorrect-password',
    defaultMessage: 'Your password was incorrect',
  },
  unknownError: {
    id: 'email-confirmation.form.unknown_error',
    defaultMessage: 'An unknown error occurred, please try again later.',
  },
});
